import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Big from 'big.js';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';
import { Invoice } from 'src/app/models/invoice';
import { Order } from 'src/app/models/order';
import { Paging } from 'src/app/models/page';
import { Payment } from 'src/app/models/payment';
import { ProductCart } from 'src/app/models/product-cart';
import { PaymentTransactionRequestModel } from 'src/app/models/request/PaymentTransactionRequestModel';
import { GiftcardRequest, GiftcardRequestEntry } from 'src/app/models/request/giftcard-request';
import { OrderRequest } from 'src/app/models/requests/order-request';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { GiftCardService } from 'src/app/services/giftcard.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import Swal from 'sweetalert2';
import { InvoiceDetailsStepComponent } from '../../invoices/invoice-stepper/invoice-details-step/invoice-details-step.component';

@Component({
  selector: 'app-giftcard-create',
  templateUrl: './giftcard-create.component.html',
  styleUrls: ['./giftcard-create.component.sass']
})
export class GiftcardCreateComponent implements OnInit {

  formCustomer: FormGroup = new FormGroup({});
  formCart: FormGroup = new FormGroup({});
  formPayments: FormGroup = new FormGroup({});
  public customer: CustomerTableModel = new CustomerTableModel();
  productCart: Paging<Array<ProductCart>> = new Paging([]);
  invoice: Invoice = new Invoice();
  simulatedOrder: Order = new Order();
  paymentRequest: Array<PaymentTransactionRequestModel> = [];
  @ViewChild("paymentsStep") paymentsStep!: InvoiceDetailsStepComponent;
  constructor(private formBuilder: FormBuilder, private invoiceService: InvoiceService, private configService: ConfigurationService, private confirmService: PosConfirmationService, private toasterService: ToastrService, private router: Router, private giftcardService: GiftCardService, private floatingService: PosFloatingActionButtonService) {
    this.formCustomer = this.formBuilder.group({
      customerFullName: "",
      customerCode: "",
      sellerCode: "",
      sellerName: "",
      rtnFiscalId: ""
    });
    this.formPayments = this.formBuilder.group({
      complete: new FormControl(false, Validators.requiredTrue)
    })

  }

  ngOnInit(): void {
  }

  getCustomerStepInfo(result: {
    customer: CustomerTableModel;
    employee: CustomerTableModel;
  }): void {
    this.customer = result.customer;
    this.customer.codeAndFullName = `[${this.customer.code}] - ${this.customer.fullName}`;
  }

  getCartForm(table: FormGroup) {
    this.formCart = table;
  }

  async getOrder(result: {
    order: Order;
    orderRequest?: OrderRequest;
    productsCart: Paging<Array<ProductCart>>;
    loanIndexChange?: number
  }): Promise<void> {
    this.productCart = result.productsCart;
    const request = new PaymentTransactionRequestModel();
    request.paymentsRequestModel.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
    request.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
    request.paymentsRequestModel.registerCode = this.configService.readRegister().code;
    request.registerCode = this.configService.readRegister().code;
    request.paymentsRequestModel.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;
    request.fromSimulatedOrder = true;
    request.simulatedOrder = result.order;
    this.simulatedOrder = result.order;
    this.invoice = (await this.invoiceService.simulatePaymentTransaction(request).toPromise()).response.invoices[0] ?? new Invoice();
  }

  getPayments(payments: { payments: Array<Payment>, paymentsAmount: number, id: string }) {
    var newRequest = this.buildPaymentTransactionRequest();
    newRequest.paymentsRequestModel.payments = payments.payments;
    this.paymentRequest = [newRequest];
    this.formPayments.controls['complete'].setValue(false);
    this.formPayments.controls['complete'].markAsPending();

    if (this.invoice.totals.netTotal > 0 && this.invoice.totals.netTotal <= Number(Big(payments.paymentsAmount).round(2).toPrecision())) {
      //Enabled next step
      this.formPayments.controls['complete'].setValue(true);
      this.formPayments.controls['complete'].markAsDirty();
    }
  }

  buildPaymentTransactionRequest() {

    const request = new PaymentTransactionRequestModel();
    request.paymentsRequestModel.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
    request.branchCode = this.configService.readSelectedBranchAndSalesOrg().branch.code;
    request.paymentsRequestModel.registerCode = this.configService.readRegister().code;
    request.registerCode = this.configService.readRegister().code;
    request.paymentsRequestModel.salesOrgCode = this.configService.readSelectedBranchAndSalesOrg().salesOrg.code;

    return request;
  }

  async pay(payments: Array<PaymentTransactionRequestModel>) {
    const giftcardRequest = this.buildGiftcardRequest(payments);
    await this.confirmService.show("Pagar", `<h3>Está seguro de generar los pagos en la tienda </br> <strong>[${this.configService.readSelectedBranchAndSalesOrg().branch.code}] ${this.configService.readSelectedBranchAndSalesOrg().branch.name}</strong> </br> con la caja </br> <strong>[${this.configService.readRegister().code}] ${this.configService.readRegister().name}</strong></h3>`, ModalDialogType.SUCCESS, async () => {
      const response = (await this.giftcardService.createGiftcard(giftcardRequest).toPromise()).response;
      if (response.giftCards.length > 0) {
        Swal.fire({
          title: `Giftcards`,
          html: `Se he generado la giftcard ${response.giftCards.map(m => m.giftCardNumber + ' ')} con la factura ${response.invoice.fullNumber} con éxito`,
          icon: 'success',
          confirmButtonText: 'Aceptar',
        });
        this.router.navigate(["giftcards", response.giftCards[0].giftCardNumber], {
          queryParams: {
            print: true
          }
        });
        return;
      };
    }, undefined, "modal-md");
  }

  buildGiftcardRequest(payments: Array<PaymentTransactionRequestModel>): GiftcardRequest {
    const request = new GiftcardRequest();
    request.customerCode = this.customer.code;
    request.requests = this.productCart.content.map(m => {
      return new GiftcardRequestEntry(m.serial, m.total);
    })
    request.paymentsRequestModel = this.buildPaymentTransactionRequest().paymentsRequestModel;
    request.paymentsRequestModel.payments = payments[0].paymentsRequestModel.payments;
    return request;
  }
  changeStep(event: StepperSelectionEvent) {
    if (event.selectedIndex == 1) {
      this.floatingService.setShow(true);
    }
    else {
      this.floatingService.setShow(false);
    }
    this.floatingService.addItems();
  }
  changeGiftcardValue($event: boolean) {
    this.paymentsStep.handleCanPayChange();
  }

}
